export default "__VITE_ASSET__v$ELSRNT__"